(function () {
    "use strict";
    $(document).ready(function () {
        var curl = window.location.href;
        $(document).on("click", ".MCLPagination a", function (e) {
            e.preventDefault();
            SpinnerSpin("");

            var $el = $(this);

            if ($("#Start").length > 0 && $("#Start").parents("form").hasClass("PagingForm")) {
                $("#Start").val($el.data("pstart"));
                $(".PagingForm").submit();
            } else if ($("#Start").length > 0 && $("#Start").parents("form").hasClass("APagingForm")) {
                var $Form = $(".APagingForm");
                $Form.find("#Start").val($el.data("pstart"));
                SpinnerSpin();
                $.ajax({
                    type: "POST",
                    url: base_url + $Form.data("controller") + "/" + $Form.data("action"),
                    data: $Form.serialize()
                }).done(function (data) {
                    $("." + $Form.data("atarget")).html(data);
                    ReinitDataTables();
                    $(".AFileForm").removeClass("NoDisplay");
                    SpinnerStop();
                });
            }
        });

        $(window).load(function () {
            if ($(".APagingForm").length > 0) {
                if ($(".APagingForm").data("submitload") == true) {
                    $(".APagingForm").submit();
                }
            }
        });

        $(document).on("submit", ".APagingForm", function (e) {
            e.preventDefault();
            
            var $Form = $(this);
            SpinnerSpin();
            $.ajax({
                type: "POST",
                url: base_url + $Form.data("controller") + "/" + $Form.data("action"),
                data: $Form.serialize()
            }).done(function (data) {
                $("." + $Form.data("atarget")).html(data);
                ReinitDataTables();
                $(".AFileForm").removeClass("NoDisplay");
                SpinnerStop();                
            });
        });
    });
})();